import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * Route component that only allows access to users with active subscriptions
 * Redirects to login if not authenticated, verify-email if not verified,
 * or checkout if authenticated but no subscription
 */
const SubscriptionRequiredRoute = ({ children }) => {
  const { isAuthenticated, isEmailVerified, user, loading, hasActiveSubscription } = useContext(AuthContext);
  
  // Show loading indicator while checking auth
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: window.location.pathname }} />;
  }
  
  // Redirect to email verification page if email is not verified
  if (!isEmailVerified) {
    return <Navigate to="/verify-email" state={{ email: user?.email }} />;
  }
  
  // Redirect to checkout if no active subscription (changed from pricing)
  if (!hasActiveSubscription) {
    return <Navigate to="/checkout" state={{ message: "Subscription required to access this feature" }} />;
  }
  
  // Return the protected content
  return children;
};

export default SubscriptionRequiredRoute;